var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "module-content" },
    [
      _c("div", { staticClass: "module-header" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c("SearchInput", {
              attrs: {
                items: _vm.items,
                attributes: _vm.tableAttributes,
                entityName: "users"
              },
              on: {
                refresh: function($event) {
                  _vm.filterItems = $event
                }
              }
            }),
            _vm.canAdd
              ? _c(
                  "button",
                  {
                    staticClass: "action",
                    attrs: { title: "Add new user", "select-cy": "create" },
                    on: {
                      click: function($event) {
                        return _vm.showCreateUser()
                      }
                    }
                  },
                  [_c("i", { staticClass: "icn icn-plus" })]
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm.isLoading
        ? _c("div", { staticClass: "container w-max" }, [_vm._m(1)])
        : _vm._e(),
      !_vm.isLoading
        ? _c("div", { staticClass: "container" }, [
            _c(
              "div",
              { staticClass: "table-wrapper" },
              [
                _c("Table", {
                  attrs: {
                    items: _vm.filterItems,
                    attributes: _vm.tableAttributes,
                    options: _vm.tableOptions
                  },
                  on: { edit: _vm.editItem, delete: _vm.deleteItem }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.isCreateOpen ? _c("UserCreate") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [_c("h2", [_vm._v("All Users")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-col items-center" }, [
      _c("img", {
        staticClass: "h-36 mt-20",
        attrs: { src: require("@/assets/img/loading.svg") }
      }),
      _c("h2", [_vm._v("Fetching users")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }